import { createContext, useMemo } from 'react';
import { useKeycloak } from '@react-keycloak/web';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const { keycloak, initialized } = useKeycloak();

    const value = useMemo(() => {
        return {
            initialized, // Essencial para evitar renderização prematura
            authenticated: keycloak?.authenticated,
            token: keycloak?.token,
            user: keycloak?.tokenParsed,
            login: () => keycloak.login(),
            logout: () =>
                keycloak.logout({ redirectUri: window.location.origin }),

            // Verificação de Role segura
            hasRole: (role) => {
                if (!keycloak) return false;
                // 1. Tenta método nativo (mais seguro)
                if (keycloak.hasRealmRole && keycloak.hasRealmRole(role))
                    return true;
                if (keycloak.hasResourceRole && keycloak.hasResourceRole(role))
                    return true;
                // 2. Fallback manual
                const roles = keycloak.tokenParsed?.realm_access?.roles || [];
                return roles.includes(role);
            },
        };
    }, [initialized, keycloak, keycloak?.token, keycloak?.authenticated]);

    return (
        <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
    );
}

export default AuthContext;
